// extracted by mini-css-extract-plugin
export default {"title":"RecentlyAddedDocument_title__n2cmi","processBox":"RecentlyAddedDocument_processBox__OAV0L"};